import React from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from 'react-router-dom';
import Spinner from '@amzn/awsui-components-core/spinner';
import '@amzn/katal-components/styles.css';
import { MbmProvider } from '@amzn/react-arb-tools';

import AppInitWrapper from 'src/components/app/AppInitWrapper';
import arbManifest from 'translations/arbManifest';
import { getMbmOptions } from 'src/utils/helpers';
import router from 'src/router';

const mbmOptions = getMbmOptions(arbManifest);

const container = document.getElementById('root');
const root = createRoot(container!);
root.render(
  <React.StrictMode>
    <AppInitWrapper>
      <MbmProvider {...mbmOptions}>
        <RouterProvider
          router={router}
          fallbackElement={<Spinner size="large" />}
        />
      </MbmProvider>
    </AppInitWrapper>
  </React.StrictMode>
);
